import { applyMiddleware, compose, createStore } from 'redux'
// import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import createMainReducer from './reducers'
import { createReduxHistoryContext } from 'redux-first-history'
import * as historyLib from 'history'
import { logUtil } from 'packages/src'

async function createReduxStore (initialState) {
  const {
    createReduxHistory,
    routerMiddleware,
    routerReducer
  } = createReduxHistoryContext({
    history: BROWSER ? historyLib.createBrowserHistory() : historyLib.createMemoryHistory()
  })
  const middlewares = [
    routerMiddleware,
    thunk
    // routerMiddleware(history)
  ]

  const composes = []
  // If the app is in development, add the loggers middlewares
  if (BROWSER && DEVELOPMENT && !TEST) {
    try {
      const reduxLogger = await import(/* webpackChunkName: "redux-logger" */ 'redux-logger')
      middlewares.push(
        reduxLogger.createLogger({
          diff: true
        })
      )
    } catch (error) {
      logUtil('createReduxStore#redux-logger').error('error=', error)
    }
  }

  // If it's in the browser, add the legacy dev tool extension
  if (
    BROWSER &&
    DEVELOPMENT &&
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
  ) {
    composes.push(window.__REDUX_DEVTOOLS_EXTENSION__())
  }

  composes.unshift(applyMiddleware.apply(null, middlewares))
  const enhancer = compose.apply(null, composes)(createStore)
  const store = enhancer(createMainReducer(routerReducer), initialState)
  const history = createReduxHistory(store)

  return {
    store,
    history
  }
}

export default createReduxStore
